import { render, staticRenderFns } from "./VisitReserve.vue?vue&type=template&id=f5044a18&scoped=true"
import script from "./VisitReserve.vue?vue&type=script&lang=js"
export * from "./VisitReserve.vue?vue&type=script&lang=js"
import style0 from "./VisitReserve.vue?vue&type=style&index=0&id=f5044a18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5044a18",
  null
  
)

export default component.exports